import { FC } from 'react';
import { BaseHealthFactor } from './components';
import { DualVariant, DualVariantProps } from './DualVariant';
import { NewVariantProps, NewVariant } from './NewVariant';
import { StaticDualVariant, StaticDualVariantProps } from './StaticDualVariant';
import { normalizeToPoints_LEGACY } from '@silo/utils';
import { StaticBar } from '@silo/ui';

interface CurrentVariantProps {
  variant: 'current';
  // percentage as a bigint
  healthFactor: bigint;
}

export type HealthFactorProps = NewVariantProps | DualVariantProps | StaticDualVariantProps | CurrentVariantProps;

export const HealthFactor: FC<HealthFactorProps> = (props) => {
  switch (props.variant) {
    case 'current': {
      const points = normalizeToPoints_LEGACY(props.healthFactor);

      return <BaseHealthFactor displayPoints={points} bar={<StaticBar points={points} />} />;
    }
    case 'dual':
      return <DualVariant {...props} />;
    case 'staticDual':
      return <StaticDualVariant {...props} />;
    case 'new':
      return <NewVariant {...props} />;
    default:
      throw new Error(`invalid variant passed`);
  }
};
